/*
 * Purpose : Tool sales Create or Edit page
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React, { useState, useEffect, useRef } from "react";
import ReactTable from "react-table";
import {NavLink, useParams} from 'react-router-dom';
import moment from 'moment';
import _ from "lodash";
import numeral from 'numeral';
import {
  Button,
  Alert,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter
} from "reactstrap";
//import { MdClose, MdDeleteForever } from 'react-icons/md';
import { MdDeleteForever } from 'react-icons/md';
//import { MdEdit, MdVisibility, MdDelete } from "react-icons/md";
import {FaPlusCircle,FaEdit} from "react-icons/fa"
//import { Col, FormGroup, Label, Input, Row, Form, FormFeedback } from "reactstrap";
import { Col, Row, Form } from "reactstrap";
import * as Yup from "yup";
import { generate } from "shortid";
// import TextField from "@material-ui/core/TextField";
// import Select from "@material-ui/core/Select";
//import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles";
//import { createMuiTheme } from "@material-ui/core/styles";
// import InputLabel from "@material-ui/core/InputLabel";
// import MenuItem from "@material-ui/core/MenuItem";
// import FormHelperText from "@material-ui/core/FormHelperText";
// import IconButton from "@material-ui/core/IconButton";
// import RemoveIcon from "@material-ui/icons/Remove";
// import AddIcon from "@material-ui/icons/Add";
// import Icon from "@material-ui/core/Icon";
// import FormControl from "@material-ui/core/FormControl";
// import {IoIosArrowDropleftCircle} from "react-icons/io";
import {FaCheckCircle} from "react-icons/fa";

//import { API, graphqlOperation, Storage } from "aws-amplify";


import "./ToolSalesInputForm.css";
//import { blue } from "@material-ui/core/colors";
import RSInput from "../../UI/CustInput/RSInput/RSInput";
import ToolSalesButton from '../../UI/Buttons/ToolSalesButton/ToolSalesButton';
import { toolDeclarationTableHeaders, errorConstants, approvalStages } from "../../../config/constants";
import AddEditToolDtls from "../AddEditToolDtls/AddEditToolDtls";
import LoadingModal from "../../../components/UI/modals/loadingModal";
import BackButton from '../../UI/Buttons/BackButton/BackButton';
import {ToolSalesFormService} from '../../../services/ToolSalesFormService';
//import { isNull } from "lodash";
import {colors} from "../../../styleConstants"
import DeleteAlertModal from "../../UI/modals/DeleteAlertModal";

const formService = new ToolSalesFormService();

// const theme = createMuiTheme({
//   palette: {
//     primary: blue,
//   },
// });

// initial form values
const initialHeaderValues = {
  transactiontype: "Tool Sales",
  date: moment().format("YYYY-MM-DD"),
  broker:"",
  buyer:"",
  l3_fab_approver:"",
  l3_fin_approver:"",
  total_price:"",                                    
  rejectedreason:"",
  comment:"",
  status:""
}

// initial form error values to make the inputs invalid or valid
const initialErrorsValues = {
  broker: null,
  buyer: null,
  l3_fab_approver: null,
  l3_fin_approver: null,
  validMail: null,
}

const ToolSalesInputForm = (props) => {
  
  const [loading, setLoading] = useState(false);
  const [brokersList, setBrokersList] = useState([]);
  const [headerData, setHeaderData] = useState(initialHeaderValues);
  const [headerDataOld, setHeaderDataOld] = useState(initialHeaderValues);
  const [toolDataOld, setToolDataOld] = useState([]);
  const [declaredToolData, setDeclaredToolData] = useState([]);
  const [nonDeclaredToolData, setNonDeclaredToolData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [modal, setModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmError, setConfirmError] = useState(null)
  const [stateValues, setStateValues] = useState({});
  const[toolList, setToolList] = useState([])
  const[fileData, setFileData] = useState({})
  const [errors, setErrors] = useState(initialErrorsValues);  
  const [deleteModal, setDeleteModal] = useState(false)
  const [row, setRow] = useState({})

  let pathParams = useParams(); // will get path params if any

  const myRef = useRef(null);

  // schema to validate the mandatory fields of the form
  const schema = Yup.object().shape({
    broker: Yup.string().required("First Name is Required"),
    buyer: Yup.string().required("Required"),
    l3_fab_approver: Yup.string().email("Not a Valid Email").required("Required")
      .test('is gf mail', "Please Enter valid GlobalFoundries email", (value) => value.split("@")[1] === "globalfoundries.com" ),
    l3_fin_approver: Yup.string().email("Not a Valid Email").required("Required")
      .test('is gf mail', "Please Enter valid GlobalFoundries email", (value) => value.split("@")[1] === "globalfoundries.com" ),
  });
  // schema to validate the mandatory text fields
  let textSchema = Yup.string().required("Required");
  // schema to validate the mandatory email fields
  let emailSchema = Yup.string().email("Invalid Email")
                        .required("Required")
                        .test('is gf mail', "Please Enter valid GlobalFoundries email", (value) => value.split("@")[1] === "globalfoundries.com" );

  const toggleModal = () => setModal(!modal);
  const addFormHandler = (declared) => {    
    //setDeclared(declared)
    setStateValues({declared_type:declared})
    setModal(true);
  };
  const editFormHandler = (editRow) =>{    
    //console.log("row->",editRow)
    //setDeclared(editRow.declared_type)
    setStateValues(editRow)
    setModal(true)
}
  // const validEmailRegex = RegExp(
  //   /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
  // );

  // to handle email changes
  const emailChangeHandler = async (event) => {
    // console.log("event.target.value=>", event.target.value);
    // console.log("event.target.name=>", event.target.name);

    //headerData[event.target.name] = event.target.value
    setHeaderData({
      ...headerData,
      [event.target.name]: event.target.value,
    });

    //if (validEmailRegex.test(event.target.value) && event.target.value) {
      //console.log("emailSchema.isValidSync(event.target.value)=>",emailSchema.isValidSync(event.target.value))
    if (emailSchema.isValidSync(event.target.value)) {
      setErrors({
        ...errors,
        [event.target.name]: false,
      });
    } else {
      setErrors({
        ...errors,
        [event.target.name]: true,
      });
    }
  };
  const inputChangeHandler = async (event) => {
    // console.log("event.target.value=>", event.target.value);
    // console.log("event.target.name=>", event.target.name);
    // setHeaderData({
    //   ...headerData,
    //   [event.target.name]: event.target.value,
    // });
    // if (event.target.value) {
    //   setErrors({
    //     ...errors,
    //     [event.target.name]: false,
    //   });
    // } else {
    //   setErrors({
    //     ...errors,
    //     [event.target.name]: true,
    //   });
    // }
    //setting file desc to file object
    // not required here as it is moved to L2
    // if(event.target.name==="description"){
    //   setFileData({
    //     ...fileData,
    //     [event.target.name]: event.target.value,
    //   })
    //   return
    // }

    setHeaderData({
      ...headerData,
      [event.target.name]: event.target.value,
    });

    //console.log("textSchema.isValidSync(event.target.value)==>",textSchema.isValidSync(event.target.value))
    if (textSchema.isValidSync(event.target.value)) {
      setErrors({
        ...errors,
        [event.target.name]: false,
      });
    } else {
      setErrors({
        ...errors,
        [event.target.name]: true,
      });
    }
  };

  // const fileChangeHandler = (event) =>{
  //   console.log("event==>",event.target.files[0])

    
  //   const url = window.URL.createObjectURL(event.target.files[0])

  //   setFileData({
  //     ...fileData,
  //     mimetype:event.target.files[0].type,
  //     name:event.target.files[0].name,  
  //     [event.target.name]: event.target.files[0], //sets file object to file
  //     url: url,
  //   })
    
  //   // const byteArray = new Uint8Array(event.target.files[0])
  //   // const blob = new Blob([event.target.files[0]], { type: event.target.files[0].type })
  //   // const url = window.URL.createObjectURL(blob)
    
  //   //const url = window.URL.createObjectURL(event.target.files[0])

  //   // setHeaderData({
  //   //   ...headerData,
  //   //   [event.target.name]: event.target.files[0],
  //   //   fileName: event.target.files[0].name,
  //   //   url: url,
  //   // });
    
  // }

  // const resetFileData = () =>{
  //   setFileData({
  //     ...fileData,
  //     mimetype:"",
  //     //name:"",  
  //     file: null, //sets file object to file
  //     url: "",
  //   })
  // }

  const getInitialFormData = async () => {   
    
    // getting dropdown data
    let dropdownList;
    try {
      dropdownList = await formService.getDropdownValues()
    } catch (error) {
      setConfirmError("There is a technical error. Please try again..!")
      return false
    }
    
    //setting brokers dropdown
    setBrokersList(dropdownList[0])
    //setting tools dropdown
    setToolList(dropdownList[1])

    //console.log('pathParams transid==>',pathParams.transid)
    if(pathParams.transid){
      try {
        const transactionDetailForEdit = await formService.getTransactionDetailForEdit(pathParams.transid)
        
        const txnResults = transactionDetailForEdit.data.listExcesstoolsalestransactionss.items[0];
        delete txnResults.date
        //delete txnResults.deal_ref
        delete txnResults.last_updated_by
        
        //console.log('txnResults==>',txnResults)
        setHeaderData({
          ...headerData,
          ...txnResults
        })
        setHeaderDataOld({
          ...headerDataOld,
          ...txnResults
        })

        // not required here as it is moved to L2
        // const txnFileResults = transactionDetailForEdit.data.listExcesstoolsalesfilesdatas.items[0];
        // console.log('txnFileResults==>',txnFileResults)      
        // s3 get
        // if(txnFileResults){
        //   const result = await Storage.get(txnFileResults.name, { download: true });
        //   //console.log("s3 get result==>",result.Body)
        //   const url = URL.createObjectURL(result.Body);
        //   //console.log(url)
        //   txnFileResults.url = url
        //   txnFileResults.file = result.Body

        //   setFileData({...fileData, ...txnFileResults})           
        // }
        
      } catch (error) {
        console.log("error=>",error)
        setLoading(false)
        setConfirmError("There is a technical error. Please try again..!")
        return false
      }

      // linked tool list 
      try {
        const linkedToolResult = await formService.getLinkedToolList(pathParams.transid)
        setToolDataOld(linkedToolResult)

        const data = linkedToolResult.map((e) => {
          const rec = { ...e };
          rec.actions = buildActions(e);
          return rec;
        });
        //console.log("data fetched",data);  
        setDeclaredToolData(data.filter( obj => obj.declared_type==="Yes"));      
        setNonDeclaredToolData(data.filter( obj => obj.declared_type==="No"));
      } catch (error) {
        console.log("error=>",error)
        setLoading(false)
        setConfirmError("There is a technical error. Please try again..!")
        return false
      }
    }
  };

  // const deleteToolFromState = (prevState,tableRow) => {
  //   // console.log("prevState in delete ==>", prevState);
  //   // console.log("tableRow==>", tableRow);

  //   // const index = _.findIndex(prevState, (o) => {
  //   //   console.log("o.id=>", o.id);
  //   //   console.log("tableRow.id=>", tableRow.id);
  //   //   return o.id === tableRow.id;
  //   // });    
  //   // let array = [...prevState];
  //   // console.log("array==>", array);
  //   // console.log("index=>", index);
  //   // array.splice(index, 1);
  //   // return array

  //   prevState.filter( toolObject => toolObject.id !== tableRow.id )
  // }

  const confirmDelete = (row) => {
      setRow(row)
      setDeleteModal(true)
  }

  const deleteTool = (tableRow) => {
    setDeleteModal(false)
    tableRow.declared_type==="Yes"
    ?
    setDeclaredToolData((prevState) => prevState.filter( toolObject => toolObject.id !== tableRow.id ) )
    :
    setNonDeclaredToolData((prevState) => prevState.filter( toolObject => toolObject.id !== tableRow.id ) )
  };

  
  const submitAddToolhandler = async (toolRecord) => {
    //console.log("toolRecord=>",toolRecord)
    
    toolRecord.id = toolRecord.id?toolRecord.id:generate()
    toolRecord.no_internal_reuse=toolRecord.no_internal_reuse?"Yes":"No"
    // toolRecord.removal_path_clear=toolRecord.removal_path_clear?"Yes":"No"
    // toolRecord.no_trade_in=toolRecord.no_trade_in?"Yes":"No"
    toolRecord.actions = buildActions(toolRecord);
    //console.log("toolRecord=>", toolRecord);

    let newRecord = toolRecord.declared_type==="Yes"?[...declaredToolData]:[...nonDeclaredToolData];
    //console.log("newRecord=>",newRecord)
    const index = _.findIndex(newRecord, (o) => {
      //console.log("o.id=>", o.id);
      console.log("toolRecord.id=>", toolRecord.id);
      return o.id === toolRecord.id;
    });
    console.log('index=>',index)

    index!==-1?(newRecord[index]=toolRecord):newRecord.push(toolRecord);

    toolRecord.declared_type==="Yes"?setDeclaredToolData(newRecord):setNonDeclaredToolData(newRecord)

    //calculating prices
    //await setPriceValues(toolRecord)

    

    setModal(false);
  };

  const buildActions = (tableRow) => {
    const actions = [];
    //console.log("tableRow=>",tableRow)
    actions.push(
      <div key={tableRow.toolid} className={"actionDivSales"}>
        {/* <Button
          className={"editBtnSales"}
          size="sm"
          color="warning"
          onClick={() => editFormHandler(tableRow) }
        >
          <MdEdit />
        </Button> */}
        <FaEdit style={{ fontSize: "21px", margin:"0 5%", color:colors.warningColor}} onClick={() => editFormHandler(tableRow) }/>
        {/* <Button
          className={"delBtnSales"}
          size="sm"
          color="danger"
          onClick={() => deleteTool(tableRow)}
        >
          <MdDelete />
        </Button> */}
        <MdDeleteForever style={{ fontSize: "21px", margin:"0 5%", color:colors.dangerColor}} onClick={() => confirmDelete(tableRow)}/>
      </div>
    );
    return actions;
  };

  const submitTxn = async(draft) => {
    setLoading(true)
    //console.log("headerData=>", headerData, "errors=>", errors, "declaredToolData=>",declaredToolData,"nonDeclaredToolData=>",nonDeclaredToolData,"fileData=>",fileData)
    if(!draft){
      const validationCheck = schema.isValidSync(headerData)
      //console.log("validationCheck==>",validationCheck)       

      setErrors({
        broker: !headerData.broker,
        buyer: !headerData.buyer,
        l3_fab_approver: !emailSchema.isValidSync(headerData.l3_fab_approver),//!headerData.l3_fab_approver,
        l3_fin_approver: !emailSchema.isValidSync(headerData.l3_fin_approver) //!headerData.l3_fin_approver
      })
      //console.log("declaredToolData length=> ",declaredToolData.length < 1)
      let errorMsg = null;
      if(!validationCheck){
        errorMsg = <p>{errorConstants.missingreqfields}</p>
        setLoading( prevState => !prevState)
        setConfirmError( errorMsg )
        return
      }
      else if( headerData.total_price < 1 ){
        errorMsg = <p>At least One Tool is required.</p>
        setLoading( prevState => !prevState)
        setConfirmError( errorMsg )
        //myRef.current.scrollIntoView()
        return
      }

      //checking duplicate tools in declared list
      let valueArr = declaredToolData.map( item => item.toolid+"~"+item.price+"~"+item.nbv+"~"+item.sales_type );
      //console.log("valueArr==>",valueArr)
      let newA = valueArr.filter( (item, idx, array) => (array.indexOf(item) !== array.lastIndexOf(item)) );
      let uniqArr = _.uniq(newA.map(item=>item.split("~")[0]))
      //console.log("uniqArr ==>",uniqArr)
      if(uniqArr.length>0){
        setLoading( prevState => !prevState)
        setConfirmError(uniqArr.map( msg => <p>{msg} is having duplicate records<br/></p> ))
        return
      }

      //checking nbv value for multiple tools in declared list
      let grouped = _.mapValues(_.groupBy(declaredToolData, 'toolid'),
                            toolList => toolList.map(tool => tool.nbv ));
      let nbvErrorList = Object.entries(grouped).map(list => {
        return (list[1].filter(x => x > 0).length > 1)?`${list[0]} is having more than one row with NBV value greater than zero.`:null
      }).filter(finalListElement=>finalListElement)
      //console.log("nbvErrorList=>",nbvErrorList)
      if(nbvErrorList.length>0){
        setLoading( prevState => !prevState)
        setConfirmError(nbvErrorList.map( msg=> <p>{msg}<br/></p> ))
        return
      }
    }
    
    let postedResult="" 
    try {
      let toolList = _.concat(declaredToolData, nonDeclaredToolData)
      console.table("toolList==>",toolList)
      //console.log("headerData=>",headerData)
      postedResult = await formService.postForm(props.user, headerData, toolList, fileData, draft, headerDataOld, toolDataOld)
      //console.log("postedResult=>",postedResult)
      setLoading( prevState => !prevState)
      
      if(!postedResult){
        setConfirmError("No new changes to submit for approval.")        
        return false
      }      
      setConfirmModal(true)
    } catch (error) {
      console.log("error=>",error)
      setLoading(false)
      setConfirmError("There is a technical error. Please try again..!")
    }
    console.log("done")
  }

  // const resetComponent = () => {
  //   setConfirmModal(!confirmModal)
  //   setLoading( prevState => !prevState)
  //   window.location.href =`/toolsales/transactions`
  // }

  useEffect(() => {
    //console.log("useeffect");    
    setLoading(true);
    const buildData = async () => {
      // set Table Headers
      const columns = [];
      Object.keys(toolDeclarationTableHeaders).forEach((col, i) => {
        if (col.toLowerCase() === "actions") {
          columns.push({
            Header: toolDeclarationTableHeaders[col],
            accessor: col,
            filterable: false,
            maxWidth: 70,
            headerClassName: 'header-style',
            className:'column-style'
            //headerClassName: 'wordwrap'
          });
        }else if( col === "toolid" ) {
          columns.push({
            Header: toolDeclarationTableHeaders[col],
            accessor: col,
            filterable: false,
            minWidth: 120,
            headerClassName: 'header-style',
            className:'column-style'
            //headerClassName: 'wordwrap'
          });
        }else if( col === "location" || col === "vendor" ) {
          columns.push({
            Header: toolDeclarationTableHeaders[col],
            accessor: col,
            filterable: false,
            minWidth: 130,
            headerClassName: 'header-style',
            className:'column-style'
            //headerClassName: 'wordwrap'
          });
        }
        else if( col === "capitalized_date" ) {
          columns.push({
            Header: toolDeclarationTableHeaders[col],
            accessor: col,
            filterable: false,
            minWidth: 130,
            headerClassName: 'header-style',
            className:'column-style-right'
            //headerClassName: 'wordwrap'
          });
        }else if( col === "remarks" || col === "fin_analysis") {
          columns.push({
            //Header: ()=><div style={{fontSize:"smaller"}}>{toolDeclarationTableHeaders[col]}</div>,
            Header:toolDeclarationTableHeaders[col],
            accessor: col,
            filterable: false,
            minWidth: 250,            
            //headerClassName: 'wordwrap'
            headerClassName: 'header-style',
            getProps: (state, rowInfo, column) => {
              //console.log("len=>",rowInfo?.row?.comment?.length) 
              // to make the data in the column wrap and size to small
              return {
                  style: {
                      whiteSpace:"unset",
                      fontSize: rowInfo?.row?.[col]?.length > 70 ? "x-small" : "smaller"
                  },
                };
            },

          });
        }
        else if(col === "price"){
          columns.push({
            Header: toolDeclarationTableHeaders[col],
            accessor: col,
            filterable: false,
            minWidth: 110,
            headerClassName: 'header-style',
            className:'column-style',
            //headerClassName: 'wordwrap'
            Cell: e=> {              
                return <div style={{textAlign:"right"}}>{numeral(e.value).format("0,0.00")}</div>              
           }
              
          });
        }
        else if(col === "org_eqp_price"){
          columns.push({
            Header: toolDeclarationTableHeaders[col],
            accessor: col,
            filterable: false,
            minWidth: 160,
            headerClassName: 'header-style',
            className:'column-style',
            //headerClassName: 'wordwrap'
            Cell: e=> {              
                return <div style={{textAlign:"right"}}>{numeral(e.value).format("0,0.00")}</div>              
           }
              
          });
        }
        else if(col === "nbv"){
          columns.push({
            Header: toolDeclarationTableHeaders[col],
            accessor: col,
            filterable: false,
            minWidth: 100,
            headerClassName: 'header-style',
            className:'column-style',
            //headerClassName: 'wordwrap'
            Cell: e=> {              
                return <div style={{textAlign:"right"}}>{numeral(e.value).format("0,0.00")}</div>              
           }
              
          });
        }else if(col === "price_percent"){
          columns.push({
            Header: toolDeclarationTableHeaders[col],
            accessor: col,
            filterable: false,
            minWidth: 215,
            headerClassName: 'header-style',
            className:'column-style',
            //headerClassName: 'wordwrap'
            Cell: e=> {              
                return <div style={{textAlign:"right"}}>{numeral(e.value).format("0,0.00")}</div>              
           }
              
          });
        }else if(col === "asset_mgt_status") {
          columns.push({
            Header: toolDeclarationTableHeaders[col],
            accessor: col,
            filterable: false,
            minWidth: 155,
            //headerClassName: 'wordwrap'
            headerClassName: 'header-style',
            className:'column-style'
          });
        }
        else if(col === "no_internal_reuse"){
          columns.push({
            Header: toolDeclarationTableHeaders[col],
            accessor: col,
            filterable: false,
            //headerClassName: 'wordwrap',
            minWidth: 300,
            headerClassName: 'header-style',
            className:'column-style',
            Cell: e=> {
              if(e.value==="Yes")              
                return <div style={{textAlign:"center"}}><FaCheckCircle color="green"/></div>
              else
                return ""
           }
              
          });
        } 
        else {
          columns.push({
            Header: toolDeclarationTableHeaders[col],
            accessor: col,
            filterable: false,
            headerClassName: 'header-style',
            className:'column-style'
            //headerClassName: 'wordwrap'
          });
        }
      });
      setColumns(columns);
      await getInitialFormData();
      // console.log("columns=>",columns)
      //console.log("data=>", data);
      //file url
      // const byteArray = new Uint8Array(file)
      // const blob = new Blob([byteArray], { type: mimeType })
      // const url = window.URL.createObjectURL(blob)

      
      
      setLoading(false);
    };

    buildData();
  }, []);

  useEffect(() => {
    //console.log("useeffect 2");
    let toolList = _.concat(declaredToolData, nonDeclaredToolData)
    console.table("toolList==>",toolList)
    let temp_total_price=0;
    let temp_total_nbv=0;
    let temp_total_gain_loss=0;
    toolList.forEach( toolObj => {
      temp_total_price = numeral(temp_total_price).add(toolObj.price).value()
      temp_total_nbv = numeral(temp_total_nbv).add(toolObj.nbv).value()      
    })
    // console.log("temp_total_price=>",temp_total_price)  
    // console.log('numeral(temp_total_price)=>',numeral(temp_total_price).format('0,0.00'))
    // console.log("temp_total_price=>",temp_total_nbv)  

    temp_total_gain_loss = numeral( numeral(temp_total_price).subtract(temp_total_nbv) ).value();
    //console.log("total_gain_loss==>",temp_total_gain_loss)

    setHeaderData({
      ...headerData,
      total_price:temp_total_price,
      total_nbv:temp_total_nbv,
      total_gain_loss:temp_total_gain_loss
    })


  }, [declaredToolData,nonDeclaredToolData])

  // useEffect(() => {
  //   window.scrollTo({
  //     top: 50,
  //     behavior: "smooth"
  //   });
  // }, [confirmError])

  return (
    <Form>
      <Alert color="danger" isOpen={confirmError != null ? true : false} toggle={()=> setConfirmError(null)}>
        {confirmError}
      </Alert>
      <div className="topBtnDiv">
        <Row form style={{ justifyContent: "flex-end" }}>
          <Col md="auto">
            <BackButton path="/toolsalesform" label="Go Back To Sales Home"/>
          </Col>
          <Col md="auto">
            <BackButton path="/toolsales/transactions" exact label="Go Back To Transactions"/>
          </Col>
        </Row>
      </div>     

      <LoadingModal open={loading} msg="Loading..." />
      <DeleteAlertModal open={deleteModal} handler={setDeleteModal} deleteHandler={deleteTool.bind(this,row)}/>
      <div className={"form"}>
        <Modal
          isOpen={modal}
          toggle={toggleModal}
          size="xl"
          draggable={false}
          centered={true}
        >
          <ModalHeader>Add/Edit Tool Details</ModalHeader>
          <ModalBody>
            <AddEditToolDtls
              submithandler={submitAddToolhandler}
              stateVals={stateValues}
              toolList={toolList}
              closeHandler={toggleModal}
            />
          </ModalBody>
        </Modal>
        <Modal isOpen={confirmModal}>
          <ModalHeader>Success!</ModalHeader>
          <ModalBody>Form has been successfully submitted.</ModalBody>
          <ModalFooter>
            <NavLink
              style={{ textDecoration: "none" }}
              to="/toolsales/transactions"
              exact
            >
              {/* <Button color="primary" onClick={resetComponent} >OK</Button>{" "} */}
              <Button color="primary" >OK</Button>{" "}
            </NavLink>
          </ModalFooter>
        </Modal>

        <div className="mainTSF">
          <div className="headerTSF">
            <h5>Transaction Details</h5>
          </div>
          <br></br>
          <br></br>
          {/* <Alert color="danger" isOpen={!errors.validMail}>Valid Email is required.</Alert> */}
          <div
            style={{ textAlign: "left", marginLeft: "2%", marginRight: "2%" }}
          >
            <Row form style={{ justifyContent: "space-evenly" }}>
              <Col md="5">
                <RSInput type="text" name="date" id="date"
                  value={headerData.date}
                  readOnly
                  required={true}
                  labelText="Date"
                />
              </Col>
            </Row>
            <Row form style={{ justifyContent: "space-evenly" }}>
              <Col md={5}>
                <RSInput type="select" name="broker" id="broker"
                    // defaultValue={headerData.broker}
                    value={headerData.broker}
                    invalid={errors.broker}
                    valid={errors.broker != null && !errors.broker}
                    onChange={(e) => inputChangeHandler(e)}
                    required={true}                 
                    labelText="Broker" >   
                    <option value="">--- Select a Broker ---</option>
                    {brokersList.map((el) => (
                      <option key={el} value={el}>{el}</option>
                    ))}                    
                </RSInput>
              </Col>
              <Col md={5}>                
                <RSInput type="text" name="buyer" id="buyer" placeholder="Enter a Buyer name..."
                  invalid={errors.buyer}
                  valid={errors.buyer != null && !errors.buyer}
                  value={headerData.buyer}
                  onChange={(e) => inputChangeHandler(e)}
                  required={true}                  
                  labelText="Buyer"
                />
              </Col>
            </Row>
            <Row form style={{ justifyContent: "space-evenly" }}>
              <Col md="5">
                <RSInput type="email" name="l3_fab_approver" id="l3_fab_approver" placeholder="Enter valid GlobalFoundries email..."
                  invalid={errors.l3_fab_approver}
                  value={headerData.l3_fab_approver}
                  valid={ errors.l3_fab_approver != null && !errors.l3_fab_approver }
                  onChange={(e) => { emailChangeHandler(e); }}
                  required={true}                  
                  labelText="L3 Fab Approver"
                />
              </Col>
              <Col md="5">
                <RSInput type="email" name="l3_fin_approver" id="l3_fin_approver" placeholder="Enter valid GlobalFoundries email..."
                  invalid={errors.l3_fin_approver}
                  value={headerData.l3_fin_approver}
                  valid={ errors.l3_fin_approver != null && !errors.l3_fin_approver }
                  onChange={(e) => { emailChangeHandler(e); }}
                  required={true}                  
                  labelText="L3 Finance Approver"
                />
              </Col>
            </Row>
          </div>
        </div>

        <div className="mainTSF">
          <div className="headerTSF">
            <h5>Tool Details</h5>
          </div>
          <br></br>
          <br></br>

          <div
            style={{
              textAlign: "left",
              marginBottom: "2%",
              marginLeft: "2%",
              marginRight: "2%",
            }}
          >
            <div ref={myRef}>
              <h5>
                Declared Tools&nbsp;&nbsp;<b style={{ color: "red" }}>*</b>
              </h5>
              <hr />
            </div>
            {/* <Button
              color="primary"
              style={{
                backgroundColor: "#fb8734",
                borderColor: "#fff",
                boxShadow: "0px 1px 2px 2px #C0C0C0",
              }}
              onClick={() => addFormHandler("Yes")}
            ><FaPlusCircle/>
              <b>Add Tool</b>
            </Button> */}
            <div>
              <span onClick={() => addFormHandler("Yes")}>
                <FaPlusCircle  style={{color:"rgb(73, 178, 240)",fontSize:"25px"}}/>&nbsp;
                <b style={{color:"#fb8734"}} >Add Tool</b>
              </span>
            </div>
          </div>
          {declaredToolData.length !== 0 ? (
            <div
              style={{
                margin: "0% 2%",
                width: "-webkit-fill-available !important",
              }}
            >
              <ReactTable
                data={declaredToolData}
                columns={columns}
                defaultPageSize={declaredToolData.length>5?10:5}
                className="-striped -highlight"
              />
            </div>
          ) : (
            <div className={"noDataDiv"}>
              <p>No data Found.!</p>
            </div>
          )}
          <br></br>
          <br></br>

          <div
            style={{
              textAlign: "left",
              marginBottom: "2%",
              marginLeft: "2%",
              marginRight: "2%",
            }}
          >
            <div>
              <h5>Non Declared Tools</h5>
              <hr />
            </div>
            <div>
              <span onClick={() => addFormHandler("No")}>
                <FaPlusCircle  style={{color:"rgb(73, 178, 240)",fontSize:"25px"}} />&nbsp;
                <b style={{color:"#fb8734"}} >Add Tool</b>
              </span>
            </div>
          </div>
          {nonDeclaredToolData.length !== 0 ? (
            <div
              style={{
                margin: "0% 2%",
                width: "-webkit-fill-available !important",
              }}
            >
              <ReactTable
                data={nonDeclaredToolData}
                columns={columns}
                defaultPageSize={nonDeclaredToolData.length>5?10:5}
                className="-striped -highlight"
              />
            </div>
          ) : (
            <div className={"noDataDiv"}>
              <p>No data Found.!</p>
            </div>
          )}
          <div
            style={{ textAlign: "left", marginLeft: "2%", marginRight: "2%" }}
          >
            <Row
              form
              style={{ justifyContent: "flex-start", marginTop: "30px" }}
            >
              <Col md="6">                
                <RSInput name="total_price" id="total_price"
                    value={"$ "+numeral(headerData.total_price).format('0,0.00')}
                    readOnly
                    required={true}
                    labelText="Total Price($US)"
                />
              </Col>
              <Col md="6">
                <RSInput name="total_nbv" id="total_nbv"
                    value={"$ "+numeral(headerData.total_nbv).format('0,0.00')}
                    readOnly
                    required={true}
                    labelText="Total NBV($US)"
                />
              </Col>
            </Row>
            <Row form style={{ justifyContent: "flex-start" }}>
              <Col md="6">                
                <RSInput name="total_gain_loss" id="total_gain_loss"
                    value={"$ "+numeral(headerData.total_gain_loss).format('0,0.00')}
                    readOnly
                    required={true}
                    labelText="Total Gain/Loss($US)"
                />
              </Col>
            </Row>
          </div>
        </div>

        <div className="mainTSF">
          <div className="headerTSF">
            <h5>Additional Details</h5>
          </div>
          <br></br>
          <br></br>
          <div
            style={{ textAlign: "left", marginLeft: "2%", marginRight: "2%" }}
          >
            <Row form style={{ justifyContent: "space-evenly" }}>
              <Col md="12">
                <RSInput type="textarea" name="rejectedreason" id="rejectedreason" placeholder=""
                    readOnly
                    value={headerData.rejectedreason}
                    onChange={(e) => inputChangeHandler(e)}
                    required={false}
                    labelText="Rejected Reasons"
                />
              </Col>
              <Col md="12">
                <RSInput type="textarea" name="comment" id="comment" placeholder="Enter comments if any..."
                    value={headerData.comment}
                    onChange={(e) => inputChangeHandler(e)}
                    required={false}
                    labelText="Comments"
                />
              </Col>
            </Row>
          </div>
        </div>
        {/* Moved to L2 approvals. Not required here as per the new change */}
        {/* <div className="mainTSF">
          <div className="headerTSF">
            <h5>File Upload</h5>
          </div>
          <br></br>
          <br></br>
          <div
            style={{ textAlign: "left", marginLeft: "2%", marginRight: "2%" }}
          >
            <Row form style={{ justifyContent: "space-evenly" }}>
              <Col md={5}>
                <FormGroup>
                  <Row form style={{ justifyContent: "space-evenly" }}>
                    <Col md="auto">
                      <Label for="description">SUTL Checklist</Label>
                    </Col>
                    <Col md="auto">
                      <Input
                        type="text"
                        name="description"
                        id="description"
                        placeholder="Enter file description..."
                        value={fileData.description}
                        onChange={(e) => inputChangeHandler(e)}
                      />
                    </Col>
                  </Row>
                </FormGroup>
              </Col>
              <Col md="5">
                <FormGroup>
                  <Input type="file" name="file" id="file"
                    onChange={(e) => fileChangeHandler(e)}
                    accept=".xlsx, .xls, .doc, .docx, .pdf, image/*"
                  />
                  <FormText color="muted">accepts pdf,word,excel,jpg,png</FormText>
                </FormGroup>

                <div
                  className={"file-wrap-sales"}
                  style={{ display: ( fileData.url && fileData.file?.type?.indexOf("image/")===-1 ) ? "inline-block" : "none" }}
                >
                  <a
                    key={fileData.name}
                    href={fileData.url}
                    download={fileData.name}
                  >
                    {" "}
                    {
                      fileData.url && (fileData?.name?.indexOf("-$") !== -1 
                      ? 
                        fileData?.name?.replace(fileData.name?.substr(fileData.name?.indexOf("-$"),10),"") 
                      : 
                        fileData.name
                      )
                    }{" "}
                  </a>
                  <MdClose className={"close"} onClick={resetFileData} />
                </div>
                <div className={"img-wrap-sales"} style={{ display: ( fileData.url && fileData.file?.type?.indexOf("image/")!==-1 ) ? "inline-block" : "none" }} >
                {" "}
                    {
                      fileData.url && (fileData?.name?.indexOf("-$") !== -1 
                      ? 
                        fileData?.name?.replace(fileData.name?.substr(fileData.name?.indexOf("-$"),10),"") 
                      : 
                        fileData.name
                      )
                    }{" "}
                    <MdClose className={"close"} onClick={resetFileData} />   
                  <img src={fileData.url} alt="problem in loading tool" width="100%" height="100%" />                        
                </div>
              </Col>
            </Row>
          </div>
        </div> */}
        {/* <div className="mainTSF">             */}
        <Alert color="danger" isOpen={confirmError != null ? true : false} toggle={()=> setConfirmError(null)} >
          {confirmError}
        </Alert>
        <div style={{ textAlign: "left", marginLeft: "2%", marginRight: "2%" }}>
          <Row form style={{ justifyContent: "flex-end" }}>            
            <Col md="auto">
              {
                headerData.status === approvalStages.l3reject 
                // ? <ToolSalesButton  onClick={() => submitTxn(false)} >Submit for L3 Approval</ToolSalesButton>
                ? <ToolSalesButton  onClick={() => submitTxn(false)} >Submit for Approval</ToolSalesButton>
                : (headerData.status === approvalStages.l3FabReject || headerData.status === approvalStages.l3FinReject)
                // ? <ToolSalesButton  onClick={() => submitTxn(false)} >Submit for L3 Fab & Finance Approval</ToolSalesButton>
                ? <ToolSalesButton  onClick={() => submitTxn(false)} >Submit for Approval</ToolSalesButton>
                : (headerData.status === approvalStages.l4reject)
                // ? <ToolSalesButton  onClick={() => submitTxn(false)} >Submit for L4 Approval</ToolSalesButton>
                ? <ToolSalesButton  onClick={() => submitTxn(false)} >Submit for Approval</ToolSalesButton>
                : (headerData.status === approvalStages.l5reject)
                // ? <ToolSalesButton  onClick={() => submitTxn(false)} >Submit for L5 Approval</ToolSalesButton>
                ? <ToolSalesButton  onClick={() => submitTxn(false)} >Submit for Approval</ToolSalesButton>
                : (headerData.status === approvalStages.approved)
                ? <ToolSalesButton  onClick={() => submitTxn(false)} >Submit</ToolSalesButton>
                : <ToolSalesButton  onClick={() => submitTxn(false)} >Submit for Approval</ToolSalesButton>
              }
              
            </Col>
            <Col md="auto">
              <ToolSalesButton style={{backgroundColor: "#778899"}} onClick={() => submitTxn(true)} >Save As Draft</ToolSalesButton>
            </Col>
            {/* <Col md="auto">
              <ToolSalesButton  onClick={() => {}} >Re-Submit for Approval</ToolSalesButton>
            </Col> */}
          </Row>
        </div>
      </div>
    </Form>
  );
};

export default ToolSalesInputForm;
